import { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { CrmColors } from '../../crm-theme';

/// `focused`: destaque de quando o Multicanal manda mostrar o card.
export const cardSx = (cc: CrmColors, statusColor: string, focused: boolean): SxProps<Theme> => ({
    bgcolor: focused ? cc.cardBgDragging : cc.cardBg,
    border: `1px solid ${focused ? cc.accent : cc.border}`,
    boxShadow: focused ? `0 0 0 3px ${cc.accentSoftBg}` : 'none',
    borderRadius: '10px',
    p: '12px 13px',
    display: 'flex',
    flexDirection: 'column',
    gap: '7px',
    cursor: 'grab',
    userSelect: 'none',
    '&:active': { cursor: 'grabbing' },
    '&:hover': { borderColor: statusColor, boxShadow: `0 2px 8px ${statusColor}22` },
    transition: 'border-color 0.15s, box-shadow 0.15s, background-color 0.15s',
});

export const tagStripSx = (color: string): SxProps<Theme> => ({
    width: 32,
    height: 5,
    borderRadius: '3px',
    bgcolor: color,
    flexShrink: 0,
});

export const hiddenTagsSx = (cc: CrmColors): SxProps<Theme> => ({
    color: cc.textSecondary,
    fontSize: '9px',
    fontWeight: 700,
    lineHeight: '5px',
});

export const amountSx = (cc: CrmColors, closed: boolean): SxProps<Theme> => ({
    color: closed ? cc.eventSuccess : cc.textSecondary,
    fontWeight: 700,
    fontVariantNumeric: 'tabular-nums',
    flexShrink: 0,
});

/// A folga só aumenta a área de clique do ícone; a margem negativa devolve o espaço.
export const channelIconAreaSx = (channelColor: string, clickable: boolean): SxProps<Theme> => ({
    display: 'flex',
    flexShrink: 0,
    p: '4px',
    m: '-4px',
    borderRadius: '6px',
    cursor: clickable ? 'pointer' : 'default',
    '&:hover': clickable ? { bgcolor: alpha(channelColor, 0.18) } : undefined,
});

export const nextScheduleSx = (cc: CrmColors, late: boolean, clickable: boolean): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    cursor: clickable ? 'pointer' : 'default',
    px: 0.6,
    py: 0.2,
    mx: -0.6,
    borderRadius: '6px',
    color: late ? cc.scheduleLate : cc.scheduleSoon,
    '&:hover': { bgcolor: cc.countBg },
});
